import React from "react";
import "./Skeleton.scss";

const Skeleton = ({
  width,
  height,
  borderRadius,
  className = "",
  style = {},
  variant = "rectangular", // 'rectangular' | 'circular' | 'rounded' | 'text'
  ...restProps
}) => {
  const customStyle = {
    width: width !== undefined ? (typeof width === "number" ? `${width}px` : width) : undefined,
    height: height !== undefined ? (typeof height === "number" ? `${height}px` : height) : undefined,
    borderRadius: borderRadius !== undefined ? (typeof borderRadius === "number" ? `${borderRadius}px` : borderRadius) : undefined,
    ...style,
  };

  return (
    <div
      className={`skeleton-base skeleton-${variant} ${className}`}
      style={customStyle}
      aria-hidden="true"
      {...restProps}
    />
  );
};

export default Skeleton;
